import { render, staticRenderFns } from "./Arrival.vue?vue&type=template&id=8e5fd8b0"
import script from "./Arrival.vue?vue&type=script&lang=ts"
export * from "./Arrival.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports